import FileIndex from '@/views/file/index';
import CommonMain from '@/views/commonMain';

export default {
  path: '/file',
  component: CommonMain,
  redirect: '/file',
  children: [
    {
      name: 'file',
      meta: { title: '文件管理' },
      path: '',
      component: FileIndex,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/file.js